"use client";

import { useState } from "react";
import { LibraryTemplate } from "src/server/zsl/templates/types";
import { PublicTemplateGrid } from "../PublicTemplateGrid";
import styles from "./ClientGrid.module.css";
import SearchInput from "../SearchInput/SearchInput";
import { MobileUseCases } from "../UseCases";
import { Category } from "src/lib/contentful/client";

type Props = {
  templates: LibraryTemplate[];
  categories: Category[];
};

export const ClientGrid = ({ templates, categories }: Props) => {
  const [query, setQuery] = useState<string>("");
  const featuredTemplates = templates.filter(
    (template) => !!template.meta.featured,
  );

  const standardTemplates = templates.filter(
    (template) => !template.meta.featured,
  );

  const filteredTemplates =
    query.length > 3 &&
    templates.filter((t) => {
      return (
        t.name.toLowerCase().includes(query.toLowerCase()) ||
        t.description?.toLowerCase().includes(query.toLowerCase())
      );
    });

  const renderFeaturedTemplates = () => {
    if (filteredTemplates) {
      return (
        <PublicTemplateGrid
          title="Search Results"
          templates={filteredTemplates}
        />
      );
    }

    return (
      <PublicTemplateGrid
        title="Featured Templates"
        templates={featuredTemplates}
      />
    );
  };

  return (
    <div>
      <div className={styles.searchWrapper}>
        <SearchInput
          value={query}
          handleChange={setQuery}
          placeholder="Search for a template"
        />
      </div>
      {renderFeaturedTemplates()}
      <MobileUseCases categories={categories} templates={templates} />
      {!filteredTemplates && (
        <PublicTemplateGrid
          title="All Templates"
          templates={standardTemplates}
        />
      )}
    </div>
  );
};
